import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { ExportManagerService } from 'shared/export-manager/export-manager.service';
import { BrandService } from 'shared/brand/brand.service';

import { ConfigureExportModalComponent } from '../configure-export-modal/configure-export-modal.component';
// eslint-disable-next-line max-len
import { ConfigureReceiverExportModalComponent } from '../configure-export-modal/configure-receiver-export-modal/configure-receiver-export-modal.component';
// eslint-disable-next-line max-len
import { ConfigureScheduleExportModalComponent } from '../configure-export-modal/configure-schedule-export-modal/configure-schedule-export-modal.component';
import { FinalModalComponent } from 'shared/modal/final-modal/final-modal.component';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'configure-export-widget',
  templateUrl: 'configure-export-widget.component.html',
})
export class ConfigureExportWidgetComponent {
  exportData: any;
  exportReceiverData: any = {};
  fileName: string;
  isPosting: boolean = false;
  exportConfigureData: any = {};

  @Input() products: Array<any> = [];
  @Input() page: string; // published, working

  @ViewChild('configureExportModal', {static: false}) configureExportModal: ConfigureExportModalComponent | void;
  @ViewChild('configureReceiverExportModal', {static: false}) configureReceiverExportModal: ConfigureReceiverExportModalComponent | void;
  @ViewChild('configureScheduleExportModal', {static: false}) configureScheduleExportModal: ConfigureScheduleExportModalComponent | void;
  @ViewChild(FinalModalComponent, {static: false}) finalExportModal: FinalModalComponent | void;

  @Output() finished: EventEmitter<any> = new EventEmitter();
  @Output() finishedReceiver: EventEmitter<any> = new EventEmitter();
  @Output() finishedScheduleExport: EventEmitter<any> = new EventEmitter();
  @Output() finalExportModalClosed: EventEmitter<any> = new EventEmitter();

  constructor(
    private exportManagerService: ExportManagerService,
    private brandService: BrandService,
    private router: Router,
  ) { }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public configureExport() {
    if (this.configureExportModal) {
      this.configureExportModal.show();
    }
  }

  public configureReceiverExport() {
    if (this.configureReceiverExportModal) {
      this.configureReceiverExportModal.show();
    }
  }

  public configureScheduleExport() {
    if (this.configureScheduleExportModal) {
      this.configureScheduleExportModal.show();
    }
  }

  public showFinalExportModal() {
    this.isPosting = false;
    if (this.finalExportModal) {
      this.finalExportModal.show();
    }
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onProductExportComplete(data: any) {
    this.finished.emit(data);
    if (this.configureExportModal) {
      this.configureExportModal.hide();
    }
  }

  onReceiverExportComplete(data: any) {
    this.finishedReceiver.emit(data);
    if (this.configureReceiverExportModal) {
      this.configureReceiverExportModal.hide();
    }
  }

  onShowScheduleExportModal(data: any) {
    this.exportConfigureData = data;
    if (this.configureExportModal) {
      this.configureExportModal.hide();
    }
    if (this.configureReceiverExportModal) {
      this.configureReceiverExportModal.hide();
    }
    if (this.configureScheduleExportModal) {
      this.configureScheduleExportModal.show();
    }
  }

  onScheduleExportComplete(data: any) {
    if (this.configureScheduleExportModal) {
      this.configureScheduleExportModal.hide();
    }
    this.finishedScheduleExport.emit(data);
  }

  onLeftBtnClick() {
    if (this.finalExportModal) {
      this.finalExportModal.hide();
    }
  }

  onRightBtnClick() {
    this.router.navigate(['export-manager']);
  }

  onFinalModalHidden() {
    this.finalExportModalClosed.emit();
  }
}
